/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as FormRouteImport } from "./routes/form"
import { Route as EmbedRouteImport } from "./routes/embed"
import { Route as LayoutRouteRouteImport } from "./routes/_layout/route"
import { Route as LayoutIndexRouteImport } from "./routes/_layout/index"
import { Route as OauthCallbackRouteImport } from "./routes/oauth.callback"
import { Route as AtpassportCallbackRouteImport } from "./routes/atpassport.callback"
import { Route as LayoutNewRouteImport } from "./routes/_layout/new"
import { Route as LayoutListRouteImport } from "./routes/_layout/list"
import { Route as LayoutEventRouteImport } from "./routes/_layout/event"
import { Route as LayoutEditRouteImport } from "./routes/_layout/edit"
import { Route as LayoutCalendarRouteImport } from "./routes/_layout/calendar"

const FormRoute = FormRouteImport.update({
  id: "/form",
  path: "/form",
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedRoute = EmbedRouteImport.update({
  id: "/embed",
  path: "/embed",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRouteRoute = LayoutRouteRouteImport.update({
  id: "/_layout",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRouteRoute,
} as any)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: "/oauth/callback",
  path: "/oauth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AtpassportCallbackRoute = AtpassportCallbackRouteImport.update({
  id: "/atpassport/callback",
  path: "/atpassport/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutNewRoute = LayoutNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutListRoute = LayoutListRouteImport.update({
  id: "/list",
  path: "/list",
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutEventRoute = LayoutEventRouteImport.update({
  id: "/event",
  path: "/event",
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutEditRoute = LayoutEditRouteImport.update({
  id: "/edit",
  path: "/edit",
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCalendarRoute = LayoutCalendarRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => LayoutRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof LayoutIndexRoute
  "/embed": typeof EmbedRoute
  "/form": typeof FormRoute
  "/calendar": typeof LayoutCalendarRoute
  "/edit": typeof LayoutEditRoute
  "/event": typeof LayoutEventRoute
  "/list": typeof LayoutListRoute
  "/new": typeof LayoutNewRoute
  "/atpassport/callback": typeof AtpassportCallbackRoute
  "/oauth/callback": typeof OauthCallbackRoute
}
export interface FileRoutesByTo {
  "/embed": typeof EmbedRoute
  "/form": typeof FormRoute
  "/calendar": typeof LayoutCalendarRoute
  "/edit": typeof LayoutEditRoute
  "/event": typeof LayoutEventRoute
  "/list": typeof LayoutListRoute
  "/new": typeof LayoutNewRoute
  "/atpassport/callback": typeof AtpassportCallbackRoute
  "/oauth/callback": typeof OauthCallbackRoute
  "/": typeof LayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_layout": typeof LayoutRouteRouteWithChildren
  "/embed": typeof EmbedRoute
  "/form": typeof FormRoute
  "/_layout/calendar": typeof LayoutCalendarRoute
  "/_layout/edit": typeof LayoutEditRoute
  "/_layout/event": typeof LayoutEventRoute
  "/_layout/list": typeof LayoutListRoute
  "/_layout/new": typeof LayoutNewRoute
  "/atpassport/callback": typeof AtpassportCallbackRoute
  "/oauth/callback": typeof OauthCallbackRoute
  "/_layout/": typeof LayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/embed"
    | "/form"
    | "/calendar"
    | "/edit"
    | "/event"
    | "/list"
    | "/new"
    | "/atpassport/callback"
    | "/oauth/callback"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/embed"
    | "/form"
    | "/calendar"
    | "/edit"
    | "/event"
    | "/list"
    | "/new"
    | "/atpassport/callback"
    | "/oauth/callback"
    | "/"
  id:
    | "__root__"
    | "/_layout"
    | "/embed"
    | "/form"
    | "/_layout/calendar"
    | "/_layout/edit"
    | "/_layout/event"
    | "/_layout/list"
    | "/_layout/new"
    | "/atpassport/callback"
    | "/oauth/callback"
    | "/_layout/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRouteRoute: typeof LayoutRouteRouteWithChildren
  EmbedRoute: typeof EmbedRoute
  FormRoute: typeof FormRoute
  AtpassportCallbackRoute: typeof AtpassportCallbackRoute
  OauthCallbackRoute: typeof OauthCallbackRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/form": {
      id: "/form"
      path: "/form"
      fullPath: "/form"
      preLoaderRoute: typeof FormRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/embed": {
      id: "/embed"
      path: "/embed"
      fullPath: "/embed"
      preLoaderRoute: typeof EmbedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout": {
      id: "/_layout"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof LayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/": {
      id: "/_layout/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    "/oauth/callback": {
      id: "/oauth/callback"
      path: "/oauth/callback"
      fullPath: "/oauth/callback"
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/atpassport/callback": {
      id: "/atpassport/callback"
      path: "/atpassport/callback"
      fullPath: "/atpassport/callback"
      preLoaderRoute: typeof AtpassportCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/new": {
      id: "/_layout/new"
      path: "/new"
      fullPath: "/new"
      preLoaderRoute: typeof LayoutNewRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    "/_layout/list": {
      id: "/_layout/list"
      path: "/list"
      fullPath: "/list"
      preLoaderRoute: typeof LayoutListRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    "/_layout/event": {
      id: "/_layout/event"
      path: "/event"
      fullPath: "/event"
      preLoaderRoute: typeof LayoutEventRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    "/_layout/edit": {
      id: "/_layout/edit"
      path: "/edit"
      fullPath: "/edit"
      preLoaderRoute: typeof LayoutEditRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    "/_layout/calendar": {
      id: "/_layout/calendar"
      path: "/calendar"
      fullPath: "/calendar"
      preLoaderRoute: typeof LayoutCalendarRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
  }
}

interface LayoutRouteRouteChildren {
  LayoutCalendarRoute: typeof LayoutCalendarRoute
  LayoutEditRoute: typeof LayoutEditRoute
  LayoutEventRoute: typeof LayoutEventRoute
  LayoutListRoute: typeof LayoutListRoute
  LayoutNewRoute: typeof LayoutNewRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteRouteChildren: LayoutRouteRouteChildren = {
  LayoutCalendarRoute: LayoutCalendarRoute,
  LayoutEditRoute: LayoutEditRoute,
  LayoutEventRoute: LayoutEventRoute,
  LayoutListRoute: LayoutListRoute,
  LayoutNewRoute: LayoutNewRoute,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteRouteWithChildren = LayoutRouteRoute._addFileChildren(
  LayoutRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LayoutRouteRoute: LayoutRouteRouteWithChildren,
  EmbedRoute: EmbedRoute,
  FormRoute: FormRoute,
  AtpassportCallbackRoute: AtpassportCallbackRoute,
  OauthCallbackRoute: OauthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
